import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LayoutService } from '@shared/services/layout.service';
import { UserService } from '@shared/services/user.service';
import { defaultLanguage } from '@shared/translation';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  constructor(private layoutService: LayoutService,
              private userService: UserService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.userService.token;
    const adminToken = this.userService.adminToken;
    const lang = this.layoutService.lang;

    request = request.clone({
      headers: new HttpHeaders({
        'lco-auth-token': token ? token : '',
        'web-auth-token': adminToken ? adminToken : '',
        'lang': lang ? lang : defaultLanguage,
        // 'app-system': 'lco-web-app'
      })
    });

    return next.handle(request);
  }
}
